import React from 'react';
import { Instagram } from 'lucide-react';
import TiktokIcon from '@/components/ui/TiktokIcon';
import { cn } from '@/lib/utils';

function PlatformToggle({ platforms, selected, onChange }) {
  const platformIcons = {
    instagram: <Instagram className="h-5 w-5" />,
    tiktok: <TiktokIcon className="h-5 w-5" />,
    youtube: (
      <svg className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor">
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
      </svg>
    )
  };

  const platformColors = {
    instagram: 'from-pink-500 to-purple-500 hover:from-pink-600 hover:to-purple-600',
    tiktok: 'from-blue-500 to-cyan-500 hover:from-blue-600 hover:to-cyan-600',
    youtube: 'from-red-500 to-rose-500 hover:from-red-600 hover:to-rose-600'
  };

  const handleToggle = (platform) => {
    if (selected.includes(platform)) {
      onChange(selected.filter(p => p !== platform));
    } else {
      onChange([...selected, platform]);
    }
  };

  return (
    <div className="space-y-3">
      {platforms.map(platform => (
        <button
          key={platform}
          onClick={() => handleToggle(platform)}
          className={cn(
            "w-full px-4 py-3 rounded-xl border-2 transition-all duration-200",
            "flex items-center gap-3",
            selected.includes(platform)
              ? `bg-gradient-to-r ${platformColors[platform]} text-white border-transparent`
              : "bg-white hover:bg-gray-50 text-gray-700 border-gray-200"
          )}
        >
          <div className={cn(
            "w-10 h-10 rounded-full flex items-center justify-center",
            selected.includes(platform)
              ? "bg-white/20"
              : "bg-gray-100"
          )}>
            {platformIcons[platform]}
          </div>
          <span className="font-medium capitalize">{platform}</span>
        </button>
      ))}
    </div>
  );
}

export default PlatformToggle; 